import { makeAutoObservable } from "mobx";

interface SelectedProduct {
  prdWidth: number;
  prdHeight: number;
  productId: number | null;
  basePrice?: number | null;
  description?: string;
  productName?: string;
  productTypeId: number | null;
  productType: string;
}

class ProductSizeStore {
  selectedProduct: SelectedProduct = { prdWidth: 0, prdHeight: 0, productId: null, basePrice: null,description: "", productName: "",productTypeId: null,productType:"" };

  constructor() {
    makeAutoObservable(this);
  }

  // Action to set the selected size and product details
  setSelectedProduct(product: SelectedProduct) {
    // Check if width and height are valid numbers before setting
    if (!isNaN(product.prdWidth) && !isNaN(product.prdHeight)) {
      this.selectedProduct = { ...product };
    } else {
      console.error("Invalid size format:", product.prdWidth, product.prdHeight);
    }
  }

  // Getter to retrieve the selected product
  get getSelectedProduct() {
    return this.selectedProduct;
  }

  // Getter to retrieve the size in pixels (assuming 72 DPI)
  get getSelectedProductDetails() {
    const DPI = 72;
    const wrapArea = 3.0 * DPI;
    return {
      width: (this.selectedProduct.prdWidth * DPI) + wrapArea,
      height: (this.selectedProduct.prdHeight * DPI) + wrapArea,
      productId: this.selectedProduct.productId,
      basePrice: this.selectedProduct.basePrice,
      description: this.selectedProduct.description,
      productName: this.selectedProduct.productName,
      productTypeId:this.selectedProduct.productTypeId,
      productType: this.selectedProduct.productType,
    };
  }
  get getSelectedAlbumProductDetails() {
    const DPI = 72;
    return {
      width: this.selectedProduct.prdWidth * DPI,
      height: this.selectedProduct.prdHeight * DPI,
      productId: this.selectedProduct.productId,
      basePrice: this.selectedProduct.basePrice,
      description: this.selectedProduct.description,
      productName: this.selectedProduct.productName,
      productTypeId:this.selectedProduct.productTypeId,
      productType: this.selectedProduct.productType,
    };
  }
}

const productSizeStore = new ProductSizeStore();
export default productSizeStore;
